import React, {useEffect, useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {useForm, Controller} from 'react-hook-form';

import styles from './ModuleSpecialRatesForm.module.scss'
import {filters} from '../../../../drupalSettings';
import ModuleDropdown from '../../../../components/ModuleDropdown';
import {pushSearchSubmitError} from 'js/helpers/gtm'
import {
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_PROMO_CODE
} from '../../../../constants';
import FieldInput from '../../../../components/FieldInput';
import {connect} from 'react-redux';
import codeApply from '../../../../actions/professionalCode';
import removePromoCode from '../../../../actions/removePromoCode';
import codeChange from '../../../../actions/codeChange';

const cx = classnames.bind(styles);
const wordings = filters?.code;
const labels = wordings?.form?.labels;
const placeholders = wordings?.form?.placeholders;
const formId = 'ModuleCodeForm';

const ModuleSpecialRatesForm = function ({
  data = [],
  onClose,
  onSubmit,
  codeApplyAction,
  codeChangeAction,
  removePromoCodeAction,
}) {
  const {
    handleSubmit,
    control,
    watch,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      [SEARCH_PARAM_CLIENT_CODE]: data[SEARCH_PARAM_CLIENT_CODE],
      [SEARCH_PARAM_CONTRACT_NUMBER]: data[SEARCH_PARAM_CONTRACT_NUMBER],
      [SEARCH_PARAM_PROMO_CODE]: data[SEARCH_PARAM_PROMO_CODE],
    }
  });
  const tempClientCode = watch(SEARCH_PARAM_CLIENT_CODE);
  const tempContractNumber = watch(SEARCH_PARAM_CONTRACT_NUMBER);
  const tempPromoCode = watch(SEARCH_PARAM_PROMO_CODE);
  const onModalClose = function () {
    onClose && onClose()
  }

  const onFormSubmit = function (formData) {
    const codeData = {
      ...data,
      ...formData,
    }
    codeApplyAction(codeData).then(() => {
      onSubmit && onSubmit()
      window.location.reload()
    }).catch((error) => {
      if (codeData.clientCode !== '' || codeData.contractNumber !== '') {
        codeChangeAction('error', error)
        pushSearchSubmitError({
          errorType: 'invalid value',
          errorField: 'client code, contract number'
        })
      } else {
        setError(SEARCH_PARAM_PROMO_CODE, {
          type: 'manual',
          message: error,
        })
        codeChangeAction('errorPromo', error)
        pushSearchSubmitError({
          errorType: 'invalid value',
          errorField: 'promo'
        })
      }
    })
  }

  const validateBusinessCodeField = function (val, sibling) {
    return (!val && !!sibling) ? 'Some error here' : true
  }

  const onPromoClear = function () {
    if (data[SEARCH_PARAM_PROMO_CODE]) {
      removePromoCodeAction(data[SEARCH_PARAM_PROMO_CODE])
      clearErrors("promoCode")
    }
  }

  const isSubmitDisabled = useMemo(function () {
    return !tempClientCode && !tempPromoCode
  }, [tempClientCode, tempPromoCode])

  const checkRenderErrors = function () {
    if (data.wrongPromoCode) {
      setError(SEARCH_PARAM_PROMO_CODE, {
        type: 'manual',
        message: data.wrongPromoCodeMessage,
      })
    }
  }

  useEffect(() => {
    checkRenderErrors()
  }, []);

  return (
    <ModuleDropdown
      title={wordings.title}
      submitTxt={wordings.apply}
      onClose={onModalClose}
      formId={formId}
      submitDisabled={isSubmitDisabled}
    >
      <form id={formId} onSubmit={handleSubmit(onFormSubmit)}>
        <div className={cx('special-rates-form')}>
          <div className={cx('field-group')}>
            <Controller
              control={control}
              name={SEARCH_PARAM_CLIENT_CODE}
              rules={{validate: (val) => validateBusinessCodeField(val, tempContractNumber)}}
              render={({field}) => (
                <FieldInput
                  label={labels[SEARCH_PARAM_CLIENT_CODE]}
                  error={errors?.[SEARCH_PARAM_CLIENT_CODE]?.message}
                  placeholder={placeholders[SEARCH_PARAM_CLIENT_CODE]}
                  {...field}
                />
              )} />
            <Controller
              control={control}
              name={SEARCH_PARAM_CONTRACT_NUMBER}
              rules={{validate: (val) => validateBusinessCodeField(val, tempClientCode)}}
              render={({field}) => (
                <FieldInput
                  className={cx('contract-number-field')}
                  label={labels[SEARCH_PARAM_CONTRACT_NUMBER]}
                  error={errors?.[SEARCH_PARAM_CONTRACT_NUMBER]?.message}
                  placeholder={placeholders[SEARCH_PARAM_CONTRACT_NUMBER]}
                  {...field}
                />
              )} />
          </div>
          <div className={cx('field-group')}>
            <Controller
              control={control}
              name={SEARCH_PARAM_PROMO_CODE}
              render={({field}) => (
                <FieldInput
                  label={labels[SEARCH_PARAM_PROMO_CODE]}
                  touched={!!errors?.[SEARCH_PARAM_PROMO_CODE]?.message}
                  error={errors?.[SEARCH_PARAM_PROMO_CODE]?.message}
                  clearable
                  onClear={onPromoClear}
                  placeholder={placeholders[SEARCH_PARAM_PROMO_CODE]}
                  {...field}
                />
              )} />
          </div>
        </div>
      </form>
    </ModuleDropdown>
  )
}

ModuleSpecialRatesForm.propTypes = {
  data: PropTypes.any
}


export default connect(null, {
  codeApplyAction: codeApply,
  codeChangeAction: codeChange,
  removePromoCodeAction: removePromoCode,
})(ModuleSpecialRatesForm)
// export default ModuleSpecialRatesForm;
